import React from "react";
import { useRecoilValue } from "recoil";
import { webImageChooser } from "../../atoms/web-image";
import WebImageChooser from "./WebImageChooser";

const WebImageChooserPortal: React.FC = () => {
    const webImageAtom = useRecoilValue(webImageChooser);
    return (
        <WebImageChooser
            visible={!!webImageAtom}
            onSelect={webImageAtom?.onSelectImage}
            onDismiss={() => {
                void webImageAtom?.onSelectImage(null);
            }}
        />
    );
};

export default WebImageChooserPortal;
